
/**
 * Get the list of available brands in the mapped values.
 * @param {Object} state
 * @returns {String[]}
 */
function brands(state) {
  if (!state.mappedItems) {
    return []
  }

  const brands = []
  state.mappedItems.forEach(value => brands.push(...value.brands));
  return [...new Set(brands)]
}

/**
 * Filter the mapped items and return a new array with objects.
 * The filter could be:
 * - The app is showing the mapped values and the item does not have a "mapped" one.
 * - The app is filtering by brand.
 * 
 * @param {Object} state
 * @returns {Object[]} with the filtered mapped items.
 */
function filteredMappedItems(state) {
  if (!state.mappedItems) return []

  let filtered = [...state.mappedItems]

  if (state.brand) {
    filtered = filtered.filter(item => item.brands.includes(state.brand))
  }

  if (state.showingMappedValues) {
    filtered = filtered.filter(item => !!item.mapped)
    // The value property is changed to "values" with an array with all the values that are mapped to this one
    const items = {}
    filtered.forEach(item => {
      if (!items[item.mapped]) {
        items[item.mapped] = { values: [], mapped: item.mapped, brands: [], frequency: 0 }
      }
      items[item.mapped].values.push(item.value)
      items[item.mapped].brands.push(...item.brands)
      items[item.mapped].frequency += item.frequency
    })
    filtered = Object.values(items).map(item => ({ ...item, brands: [...new Set(item.brands)] }))
  }

  return filtered
}


/**
 * Get the mapped items but grouped by the mapped value.
 * - Change the "value" property for the "values" property with the values objects accumulated.
 * - Accumulate the frequency of the different values.
 * - Accumulate the brands of the different values.
 * @param {Object} state
 * @returns {Object[]}
 */
function groupedMappedItems(state) {
  if (!state.mappedItems) return []

  const items = state.mappedItems.filter(item => !!item.mapped)
  const keyed = {}
  items.forEach(item => {
    if (!keyed[item.mapped]) {
      keyed[item.mapped] = { values: [], mapped: item.mapped, brands: [], frequency: 0 }
    }
    keyed[item.mapped].values.push(item)
    keyed[item.mapped].brands.push(...item.brands)
    keyed[item.mapped].frequency += item.frequency
  })
  return Object.values(keyed).map(item => ({ ...item, brands: [...new Set(item.brands)] }))
}

export default {
  brands,
  filteredMappedItems,
  groupedMappedItems
}